import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../Avatar';
import Link from '../Link';
import messages from '../../locale/messages';
import StarRating from '../StarRating/StarRating';

import { LinkIndicateIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';
import s from './Reviews.css';

const ReviewItem = (props) => {
  const {
    firstName,
    lastName,
    profileId,
    picture,
    otherUserName,
    otherUserProfileId,
    isAdmin,
    listTitle,
    reviewContent,
    createdAt,
    response,
    showUserName,
    rating,
    listData,
    current,
    reservationId
  } = props;

  const { formatMessage } = useIntl();
  const dispatch = useDispatch(); // You can use this if needed

  const siteName = useSelector((state) => state.siteSettings?.data?.siteName);

  const date = moment(parseInt(createdAt)).format('MM/DD/YYYY');

  const isGuestImage = response?.authorData?.picture;
  const isGuestProfileId = response?.authorData?.profileId;
  const showAvatar = !showUserName ? picture : isGuestImage;
  const isProfileId = !showUserName ? profileId : isGuestProfileId;

  return (
    <li>
      <div className={s.listAvatarGrid}>
        <div>
          {!isAdmin && (
            <div className={cx(s.pullRight, s.mediaContainer, s.textCenter, 'reviewsId')}>
              <Avatar
                source={showAvatar}
                height={48}
                width={48}
                title={firstName}
                className={s.profileAvatar}
                withLink
                linkClassName={cx(s.profileAvatarLink, s.noBackground)}
                profileId={isProfileId}
              />
            </div>
          )}
          {isAdmin && (
            <div className={cx(s.pullRight, s.mediaContainer, s.textCenter, 'reviewsId')}>
              <Avatar
                source='../../../adminAvatar.png'
                height={48}
                width={48}
                title={`${formatMessage(messages.verifiedBy)} ${siteName}`}
                className={cx(s.profileAvatar, s.noBackground)}
                staticImage
              />
            </div>
          )}
        </div>

        <div className={cx(s.listDeatilsGrid, 'listingTagCurve whiteBgCurve')}>
          <div className={s.reviewBody}>
            {showUserName && (
              <span className={cx(s.textBold, s.writtenReviewTitle)}>
                <FormattedMessage {...messages.Youhadreviewsfor} />{' '}
                <Link to={`/users/show/${otherUserProfileId}`}>{otherUserName}</Link>:
              </span>
            )}

            {isAdmin && (
              <div className={s.nameBold}>
                {`${formatMessage(messages.verifiedBy)} ${siteName}`}
              </div>
            )}

            {!isAdmin && !showUserName && (
              <div className={s.nameBold}>
                {listData ? (
                  <>
                    {firstName}
                    <span>{' '}<FormattedMessage {...messages.sreview} />{' '}</span>
                    <Link to={`/rooms/${listData.id}`}>{listTitle || listData.title}</Link>
                  </>
                ) : (
                  <FormattedMessage {...messages.listingNotAvailable} />
                )}
              </div>
            )}

            {reviewContent && (
              <div className={s.reviewFlex}>
                <StarRating className='smallStarRatingAdjust' />
                <div>{rating}</div>
                <div className={cx(s.dateReviewCss, 'dateReviewCssRTL')}>{date}</div>
              </div>
            )}

            <p className={cx(s.contentTop, { [s.noResponse]: isAdmin })}>
              {reviewContent &&
                reviewContent.trim().split('\n').map((content, index) => (
                  <span key={index}>
                    {content}
                    <br />
                  </span>
                ))}
            </p>

            {!isAdmin && current === 'notResponded' && (
              <div className={cx(s.rightText)}>
                <Link to={`/review/write/${reservationId}`}>
                  <FormattedMessage {...messages.reply} />
                  <LinkIndicateIcon className='replyArrowRTL' />
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

ReviewItem.propTypes = {
  formatMessage: PropTypes.any,
  picture: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profileId: PropTypes.number,
  reviewContent: PropTypes.string,
  createdAt: PropTypes.string,
  response: PropTypes.object,
  otherUserResponse: PropTypes.bool,
  showUserName: PropTypes.bool,
  otherUserName: PropTypes.string,
  otherUserProfileId: PropTypes.number,
  isAdmin: PropTypes.bool,
  listTitle: PropTypes.string,
  rating: PropTypes.number,
  listData: PropTypes.object,
  current: PropTypes.string,
  reservationId: PropTypes.number,
};

ReviewItem.defaultProps = {
  response: null,
  showUserName: false
};

export default withStyles(s)(ReviewItem);